<template>
  <cms-shell :data="data" title="Video" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
    <input type="text" class="form-control" v-model="data.id" placeholder="Youtube Video Id"/>
    <youtube :video-id="data.id" style="margin-top: 1rem"/>
  </cms-shell>
</template>


<script>
  import CmsShell from "./CmsShell";

  export default {
    components: {CmsShell},
    name: "cms-video",
    props: ['data']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsVideo.vue